import React, { useState, useEffect } from "react";
import Loading from "../components/Loading";
import DenyAccess from "../components/DenyAccess";
import Networks from "../network";
import hasPermission from "./hasPermission";
import Cookies from "js-cookie";

interface Optional {
  byPassProfile?: boolean;
  permissionAccess?: {
    message?: string,
    accessEmployeeCodes?: string[],
    accessPermission?: string,
  };
}

const peepLogin = (whiteList, optional: Optional) => (Wrapped) => (props) => {
  if (process.env.REACT_APP_BY_PASS_LINE === 'YES') {
    return <Wrapped {...props} />
  } else {
    const [hasLogin, setHasLogin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState(null);
    const [user, setUser] = useState({
      id: null,
      employee_code: "",
      name: "",
      type: {
        id: null,
        name: "",
      },
      permission_types: [],
    });
    const [peepShareId, setPeepShareId] = useState(null);
  
    const initUser = async (cookie_name, access_token) => {
      const { statusOk, data } = await Networks.getPeepAccessProfile(
        access_token
      );
      if (!statusOk) {
        let msg = null;
        if (data?.code === "INVALID_TOKEN") {
          msg = "ดึงข้อมูลไม่สำเร็จ code: INVALID_TOKEN";
        } else {
          msg = data?.info || null;
        }
        setErrorMsg(msg);
        return false;
      } else {
        Cookies.remove(cookie_name);
        Cookies.set(
          cookie_name,
          JSON.stringify({
            ...data,
            access_token,
          }),
          {
            expires: 7,
          }
        );
        return data;
      }
    };
  
    const clearToken = () => {
      const url = new URL(window.location.href);
      if (url.searchParams.has("token")) {
        url.searchParams.delete("token");
        window.history.replaceState({}, "", url.toString());
      }
    };
  
    const getProfilePeep = async () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const access_token = urlParams.get("token");
      const cookie_name = `peep_share_profile`;
      const profile = Cookies.get(cookie_name);
      if (!profile) {
        const peep_access_profile = await initUser(cookie_name, access_token);
        clearToken();
        return peep_access_profile;
      } else {
        const d = Cookies.get(cookie_name);
        let peep_access_profile = JSON.parse(d);
        if (access_token && peep_access_profile.access_token !== access_token) {
          peep_access_profile = await initUser(cookie_name, access_token);
        }
        clearToken();
        return peep_access_profile;
      }
    };
  
    useEffect(() => {
      (async () => {
        const profile = await getProfilePeep();
        if (!profile) {
          setHasLogin(false);
          setLoading(false);
          return;
        } else {
          const { public_id } = profile;
          const res = await Networks.getMemberProfilePeepShare(public_id);
          if (!res.statusOk) {
            const msg =
              "ดึงข้อมูลไม่สำเร็จ code: " + (res?.statusCode || "Unknown");
            setErrorMsg(msg);
            setHasLogin(false);
            setLoading(false);
            return;
          }
          const _user = {
            ...user,
            id: res.data.id,
            employee_code: res?.data?.employee_code,
            name: res?.data?.name,
            type: res?.data?.type,
            permission_types: res?.data?.permission_types || [],
          };
          setUser(_user);
          setHasLogin(true);
          setLoading(false);
          setPeepShareId(public_id);
        }
      })();
    }, []);
  
    return loading ? (
      <Loading backdropColor="#fff" opacity={1} show={true} variant="primary" />
    ) : hasLogin &&
      hasPermission({
        employeeCode: user.employee_code,
        permissionTypes: user.permission_types,
        ...optional?.permissionAccess,
      }) ? (
      <Wrapped {...props} user={{ ...user, peepShareId }} />
    ) : (
      <DenyAccess
        from={"peep"}
        msg={
          !!user.id &&
          !hasPermission({
            employeeCode: user.employee_code,
            permissionTypes: user.permission_types,
            ...optional?.permissionAccess,
          })
            ? optional?.permissionAccess?.message
            : errorMsg
        }
      />
    );
  }
};

export default peepLogin;
